module.exports = __webpack_public_path__ + "img/cloudview_music-list.57b4631a.jpg";